<template>
  <v-app :dark="isdark">
    <div class="d-flex flex-column h-100">
      <div align-center class="flex-grow-1">
        <TheHeader v-if="out_routes.includes(current_route)" :goDark="isdark" />
        <transition
          name="router-animation"
          mode="out-in"
          enter-active-class="animated fadeIn fast"
          leave-active-class="animated fadeOut faster"
        >
          <router-view></router-view>
        </transition>
      </div>
      <TheFooter v-if="out_routes.includes(current_route)" />
    </div>
    <!-- <div class=" position-fixed d-flex align-items-center fixed-bottom z-2 px-2" style="z-index: 1040" v-if="globalError">
      <v-alert
       class= "alert-error"
        type="error"
      >Nous n'arrivons pas a contacter le serveur. Veuillez reessayer plus tard</v-alert>
    </div> -->
  </v-app>
</template>

<script>
import TheHeader from "./components/TheHeader";
import TheFooter from "./components/TheFooter";

import Vuetify from "vuetify/lib";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    TheHeader,
    TheFooter,
  },
  data() {
    return {
      out_routes: [
        "Home",
        "demand",
        "register",
        "login",
        "Contact",
        "Confirm",
        "Payment",
        "Faq",
        "ResetPassword",
        "AskEmail",
        "Takerdv",
        "Ticket",
        "Edocument",
      ],

      //goDark: false ,
      opts: {
        theme: {
          dark: false,
        },
      },
      vuetify: new Vuetify(this.opts),
    };
  },
  created() {
    console.log(this.current_route);

    this.$vuetify.theme.dark = this.isdark;
    this.$store.dispatch("setdark", this.isdark);
  },
  watch: {
    isdark(value) {
      this.$vuetify.theme.dark = value;
    },
  },
  computed: {
    ...mapGetters(["current_route", "globalError", "isdark"]),
  },
  methods: {},
};
</script>
<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css";
</style>
